import {
  createError,
  defineNuxtRouteMiddleware,
  useRuntimeConfig,
} from '#imports'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export const iphone17EventPage = defineNuxtRouteMiddleware(() => {
  const { FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE = '' } =
    useRuntimeConfig().public
  const { countryCode } = useMarketplace().market

  if (!FF_PRODUCT_PAGE_IPHONE_17_EVENT_PAGE.includes(countryCode)) {
    throw createError({
      statusCode: 404,
      statusMessage: 'iPhone 17 page is not active',
    })
  }
})
